<template>
    <span>
        <base-button :icon="isIcon" size="sm" style="margin-bottom: 4px;" :disabled="isReadOnly || isPartnerAccount" :class="isIcon? 'btn-link':'btn_extra_small btn_info white'" @click.native="viewItem">
            <slot name="modal-link"></slot>
        </base-button>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">FUND CITATION</h4>
            <hr />
            <div class="container">
                <label for="fundCitation">Finance System</label>
                <v-select 
                    :key="selectKey" 
                    v-model="financeSystem.financeSystemId" 
                    :reduce="f => f.financeSystemId" 
                    label="name" 
                    :options="financeSystems?.filter((e)=> e.name != 'ARMY STANFINS LOA')" 
                    placeholder="Select"
                    name="fundCitation"
                    data-vv-as="Fund Citation"
                    :class="errors.has('fundCitation') ? 'has-danger' : ''"
                    v-validate="'required'"
                    :error="getError('fundCitation')"
                ></v-select>
            <span v-show="errors.has('fundCitation')" class="error"
          >{{ errors.first("fundCitation") }}
         </span>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4" @click.native="modals.classic = false">
                        Close
                    </base-button>
                    <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="submit">
                        Submit
                    </base-button>
                </div>
            </template>
        </modal>

    </span>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { BaseButton, Modal } from '@/components';
    import { normalizeSelectModel } from '@/util/formUtils';

    export default {
        name: "finance-system-modal",
        props: {
            isIcon: {
                type: Boolean,
                default: false
            },
            isReadOnly:{ 
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                modals: {
                    classic: false,
                },
                selectKey: 0 // for re-rendering the select component
            };
        },
        components: {
            BaseButton,
            Modal
        },
        mounted(){
        },
        computed: {
            ...mapGetters({
                financeSystem: 'orderFinanceSystem/orderFinanceSystem',
                financeSystems: 'financeSystems/financeSystems',
                isPartnerAccount: "authentication/isPartnerAccount"
            })
        },
        methods: {
            ...mapActions({
                getFinanceSystem: 'orderFinanceSystem/getOrderFinanceSystem',
                saveFinanceSystem: 'orderFinanceSystem/saveOrderFinanceSystem',
                getFinanceSystems: 'financeSystems/getFinanceSystems',

            }),
            viewItem() {
                let ctx = this;
                if (this.$validator) {
                  this.$validator.reset();
                }

                ctx.getFinanceSystems().then(() => {
                    ctx.getFinanceSystem(ctx.$route.params.id).then(() => {
                        const normalizedId = normalizeSelectModel(ctx.financeSystem.financeSystemId);
                        ctx.financeSystem.financeSystemId = normalizedId;

                        // Increment key before opening modal to force re-render
                        ctx.selectKey += 1;
                        ctx.modals.classic = true;
                    }).catch(error => {
                         console.error("Error fetching finance system:", error);
                         this.$toast.error("Failed to load finance system information.");
                    });
                }).catch(error => {
                     console.error("Error fetching finance systems list:", error);
                     this.$toast.error("Failed to load finance system options.");
                     // ctx.modals.classic = true;
                });
            },
            submit(e) {
                let ctx = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        ctx.saveFinanceSystem(ctx.$route.params.id).then(response => {
                            ctx.getFinanceSystem(ctx.$route.params.id)
                            ctx.modals.classic = false
                        })
                    } else {
                        this.$toast.error("Please fill the required fields.");
                    }
                })
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            stockClassOnChange(value) {
                this.clearStockSubClass();
                this.getStockSubClasses(value);
            }
        }
    }
</script>

